import { inject, Injectable } from '@angular/core';
import { TranslatorService } from '@app/services/translator/translator.service';

@Injectable({
  providedIn: 'root',
})
export class AcceptedDomainsService {
  private readonly translatorService = inject(TranslatorService);
  acceptedDomainsText(domains: string[] = []) {
    if (!domains || domains.length === 0) {
      return '';
    }

    if (domains.length === 1) {
      const acceptedDomainText = this.translatorService.translate(
        'users.acceptedDomain'
      );
      return `${acceptedDomainText}: ${domains[0]}`;
    }
    const acceptedDomainsText = this.translatorService.translate(
      'users.acceptedDomains'
    );
    const remainingDomains = domains.slice(0, -1);
    const lastDomain = domains[domains.length - 1];

    return `${acceptedDomainsText} are: ${remainingDomains.join(
      ', '
    )} or ${lastDomain}`;
  }
}
